import { t } from '$i18n'
import { closeJoinHallRequests } from '$logic/router'
import { WithAppBarAndActionButton } from '$common/searchable-list-page/with-appbar-and-action-button'
import { JoinHallRequestList } from '$common/join-channel-requests/join-hall-request-list'

interface Props {
  roomId: string
}

export function HallJoinRequests({ roomId }: Props) {
  return (
    <WithAppBarAndActionButton
      appBarTitle={t('JoinHallRequests.list.title')}
      onBack={closeJoinHallRequests}
      useCustomScroller
    >
      {(listHeight: number, searchQuery: string) => (
        <JoinHallRequestList
          roomId={roomId}
          height={listHeight}
          searchQuery={searchQuery}
        />
      )}
    </WithAppBarAndActionButton>
  )
}
